package com.sweetlime.bingeamigo.repository

import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.Timestamp

class FirebaseNotificationRepository(
    private val firestore: FirebaseFirestore
) : NotificationRepository {

    override suspend fun saveFcmToken(userId: String, token: String) {
        firestore.collection("users")
            .document(userId)
            .collection("fcmTokens")
            .document(token)
            .set(mapOf("token" to token, "updatedAt" to Timestamp.now()))
    }

    override suspend fun removeFcmToken(userId: String, token: String) {
        firestore.collection("users")
            .document(userId)
            .collection("fcmTokens")
            .document(token)
            .delete()
    }
}